import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';

import { useEmailClientConnect } from '@shared/email/emailClientConnect';
import { useLocale } from '@shared/hooks/locale';

type Props = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

export const ReconnectEmailDialog = ({ open, onClose, onSuccess }: Props) => {
  const { t } = useLocale();
  const connectEmailClient = useEmailClientConnect();

  return (
    <Dialog maxWidth="xs" open={open} onClose={onClose}>
      <DialogTitle>{t('You need to reconnect your email')}</DialogTitle>
      <DialogActions>
        <Button onClick={onClose}>{t('Cancel')}</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            connectEmailClient(error => {
              if (error == null) {
                onSuccess();
              } else {
                onClose();
              }
            });
          }}
        >
          {t('Reconnect email')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
